export default __webpack_public_path__ + "static/media/Link.2cb3cabc.png";